import { ActionTree } from "vuex";
import { RootState } from "@/store/types";
import { ACTION_TYPES } from "@/lib/const";
import {
  InputPaymentPackageCreate,
  InputPaymentPackageUpdate,
} from "@teacherskaya/api-provider/dist/api/PaymentPackageProvider";
import providers from "@/lib/providers";

export const actions: ActionTree<unknown, RootState> = {
  async [ACTION_TYPES.GET_DATA](context, { type }: { type?: string[] }) {
    return providers.PaymentPackageProvider.findAll({ type });
  },
  async [ACTION_TYPES.ADD_DATA](context, { data }: { data: InputPaymentPackageCreate }) {
    return providers.PaymentPackageProvider.create({ data });
  },
  async [ACTION_TYPES.SET_DATA](context, { data }: { data: InputPaymentPackageUpdate }) {
    return providers.PaymentPackageProvider.update({ data });
  },
  async [ACTION_TYPES.DEL_DATA](context, { packageId }: { packageId: string }) {
    return providers.PaymentPackageProvider.delete({ packageId });
  },
};
